<div class="tp-wrap" [class.tp-disabled]="disabled">
  <span class="tp-label">{{ label }}</span>

  <div class="tp-controls">
    <!-- Hour: plain number input, 1–12 -->
    <input
      class="tp-segment"
      type="text"
      inputmode="numeric"
      [value]="hourDisplay"
      [disabled]="disabled"
      (input)="onHourInput($any($event.target).value)"
      (blur)="onHourBlur()"
      (keydown)="onSegmentKeydown($event)"
      placeholder="h"
      autocomplete="off"
      maxlength="2"
    />

    <span class="tp-colon">:</span>

    <!-- Minute: plain number input, 00–59 -->
    <input
      class="tp-segment"
      type="text"
      inputmode="numeric"
      [value]="minuteDisplay"
      [disabled]="disabled"
      (input)="onMinuteInput($any($event.target).value)"
      (blur)="onMinuteBlur()"
      (keydown)="onSegmentKeydown($event)"
      placeholder="mm"
      autocomplete="off"
      maxlength="2"
    />

    <!-- AM / PM toggle -->
    <mat-button-toggle-group
      class="tp-period"
      [value]="period"
      [disabled]="disabled"
      (change)="onPeriodChange($event.value)">
      <mat-button-toggle value="AM">AM</mat-button-toggle>
      <mat-button-toggle value="PM">PM</mat-button-toggle>
    </mat-button-toggle-group>
  </div>
</div>
